export default __webpack_public_path__ + "static/media/doc.6e5a4d42.svg";